import { useMemo } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { LinkNamesContext } from '@/modules/links/linkNames';
import type { Goal, Project, Subject } from '@/domain/types';

/** Laedt Projekte und Ziele einmal fuer die ganze App - siehe `linkNames.ts`. */
export function LinkNamesProvider({ children }: { children: React.ReactNode }) {
  const daten = useLiveQuery(
    async () => {
      const [projects, goals, subjects] = await Promise.all([db.projects.toArray(), db.goals.toArray(), db.subjects.toArray()]);
      return { projects, goals, subjects };
    },
    [],
    { projects: [] as Project[], goals: [] as Goal[], subjects: [] as Subject[] },
  );

  const wert = useMemo(() => ({
    projects: new Map(daten.projects.map((p) => [p.id, p])),
    goals: new Map(daten.goals.map((g) => [g.id, g])),
    subjects: new Map(daten.subjects.map((s) => [s.id, s])),
  }), [daten]);

  return <LinkNamesContext.Provider value={wert}>{children}</LinkNamesContext.Provider>;
}
